export default function Spacer({ height = "20px" }) {
  return <div className="spacer" style={{ height: height }}></div>;
}
